import { createStyles, fade } from '@material-ui/core/styles'
import { sharedInputStyles } from 'swisscard/components/form/shared_input_styles'

import type { Theme } from '@material-ui/core/styles'

export const autocompleteStyles = (theme: Theme) => {
  return createStyles({
    ...sharedInputStyles(theme), // include of the default input styles

    // autocomplete list
    listClassName: {
      left: 0,
      right: 0,
      backgroundColor: theme.customColors.input.default.filled.background,
      zIndex: 3000,
      marginTop: -5,
      boxShadow: `0 6px 8px ${fade(theme.palette.common.black, 0.21)}, 0 1px 2px ${fade(
        theme.palette.common.black,
        0.23,
      )}`,
      listStyleType: 'none',
      padding: '4px 0',
    },
    listClassNameNoResults: {
      backgroundColor: theme.customColors.input.default.empty.background,
      padding: 0,
    },

    // autocomplete list entry
    listEntryClassName: {
      padding: '10px 20px',
      listStyleType: 'none',
      cursor: 'pointer',

      '&::before': {
        content: "'' !important",
      },

      '&:b': {
        fontWeight: 'bold',
      },

      '&:hover': {
        backgroundColor: theme.palette.common.white,
      },
    },
    listEntryClassNameNoResults: {
      listStyleType: 'none',
      backgroundColor: theme.customColors.input.default.disabled.background,
      fontSize: 14,
      padding: '4px 8px',
      pointerEvents: 'none',
    },

    selectedEntryClassName: {
      backgroundColor: theme.palette.common.white,
      padding: '9px 19px',
      border: `2px solid ${theme.customColors.input.default.filled.text}`,
    },
  })
}
